import React from 'react'
import EdicionAutodescargable from '../../../Camiones/components/EdicionAutodescargable'
import { actualizarCamionesCalados } from '../../actions'
import { connect } from 'react-redux'

function AutodescargableEnCalado (props) {
  const { cea, actualizarCamionesCalados } = props

  const actualizar = () => {
    actualizarCamionesCalados()
  }

  return (
    <EdicionAutodescargable cea={cea} actualizarData={actualizar} />
  )
}

const mapActionsToProps = {
  actualizarCamionesCalados
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(AutodescargableEnCalado)
